"use strict";
/*!
 *
 *  size-change.ts
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.size = 16;
        this.min = 10;
        this.max = 24;
        if ($.cookie('nnmfs')) {
            this.size = $.cookie('nnmfs');
        }
        ;
        this.setSize();
        $('.st-Header_SizeChange_Btn').on('click', function (e) {
            e.preventDefault();
            if ($(e.currentTarget).is('.-s')) {
                if (_this.size === _this.min) {
                    alert('これ以上文字サイズを小さくできません。\n「中」ボタンを選択すると標準の文字サイズに戻ります。');
                }
                else {
                    _this.size--;
                    _this.setSize();
                }
                ;
            }
            else if ($(e.currentTarget).is('.-m')) {
                _this.size = 16;
                _this.setSize();
            }
            else if ($(e.currentTarget).is('.-l')) {
                if (_this.size === _this.max) {
                    alert('これ以上文字サイズを大きくできません。\n「中」ボタンを選択すると標準の文字サイズに戻ります。');
                }
                else {
                    _this.size++;
                    _this.setSize();
                }
                ;
            }
            ;
        });
    }
    default_1.prototype.setSize = function () {
        $.cookie('nnmfs', this.size, {
            expires: 30
        });
        $('html').css('font-size', this.size + 'px');
    };
    return default_1;
}());
exports.default = default_1;
;
